// extracted by mini-css-extract-plugin
module.exports = {"list":"NoteList_list__3Op8p"};